import { handleHttpError, isFileBig, obterCorPorStatus } from '../utils';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import CircularProgress from '@mui/material/CircularProgress';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import DeleteIcon from '@mui/icons-material/Delete';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import React from 'react';
import { useSnackbar } from '../hooks/useSnackbar';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Moment from 'moment';
import { useQuery } from '../hooks/useQuery';

const TIPO_ARQUIVOS_PERMITIDOS = ['pdf'];

export const RowDocumentFornecedor = ({
  number,
  title,
  type,
  fornecedor_id,
  onUploaded,
  fileUploaded,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [dtEmissao, setDtEmissao] = React.useState(
    fileUploaded ? fileUploaded.data_emissao : '',
  );
  const [dtValidade, setDtValidade] = React.useState(
    fileUploaded ? fileUploaded.data_validade : '',
  );
  const snackbar = useSnackbar();

  const {
    enviarArquivosFornecedor,
    atualizarArquivoFornecedor,
    deletarArquivoFornecedor,
  } = useQuery();

  const onChangeFile = async (event) => {
    const files = [...event.target.files];
    if (!files.length) return;
    const file = files[0];
    const extension = file.name.split('.').pop();

    if (!TIPO_ARQUIVOS_PERMITIDOS.includes(extension)) {
      snackbar.showSnackbar(
        'Tipo de arquivo inválido. Somente ' +
          TIPO_ARQUIVOS_PERMITIDOS.join(','),
      );
      setFile(null);
      return;
    }

    if (isFileBig(file.size)) {
      snackbar.showSnackbar('Tamanho de arquivo inválido. Máximo é 10MB');
      return;
    }
    const formData = new FormData();
    formData.append('arquivo', file);
    formData.append('tipo', type);
    formData.append('descricao', title);
    formData.append(
      'data_emissao',
      dtEmissao ? Moment(dtEmissao).format('YYYY-MM-DD') : '',
    );
    formData.append(
      'data_validade',
      dtValidade ? Moment(dtValidade).format('YYYY-MM-DD') : '',
    );

    try {
      setLoading(true);
      await enviarArquivosFornecedor(fornecedor_id, formData);
      onUploaded();
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      setLoading(false);
    }
  };

  const onChangeDtEmissao = async (event) => {
    setDtEmissao(event);

    if (!fileUploaded) return;

    try {
      setLoading(true);
      await atualizarArquivoFornecedor(fileUploaded.id, {
        data_emissao: Moment(event).format('YYYY-MM-DD'),
        status:
          fileUploaded && fileUploaded.status
            ? fileUploaded.status
            : 'PENDENTE',
      });
      onUploaded();
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      setLoading(false);
    }
  };

  const onClickDelete = async () => {
    if (!fileUploaded) return;

    try {
      setLoading(true);
      await deletarArquivoFornecedor(fileUploaded.id);
      onUploaded();
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      setLoading(false);
    }
  };

  const onChangeDtValidate = async (event) => {
    setDtValidade(event);
    if (!fileUploaded) return;

    try {
      setLoading(true);
      await atualizarArquivoFornecedor(fileUploaded.id, {
        data_validade: Moment(event).format('YYYY-MM-DD'),
        status:
          fileUploaded && fileUploaded.status
            ? fileUploaded.status
            : 'PENDENTE',
      });
      onUploaded();
    } catch (error) {
      snackbar.showSnackbar(handleHttpError(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <tr style={{ background: 'white' }}>
      <td style={{ paddingLeft: '1.2rem' }}>
        <b style={{ color: '#0e72b8' }}>{number}</b>
      </td>
      <td style={{ paddingLeft: '1.2rem' }}>{title}</td>
      <td style={{ paddingLeft: '1.2rem' }}>
        <Button
          style={{
            borderRadius: 20,
            width: '100%',
            fontSize: 10,
          }}
          variant="contained"
          color={obterCorPorStatus(
            fileUploaded && fileUploaded.status
              ? fileUploaded.status
              : 'PENDENTE',
          )}
        >
          {fileUploaded && fileUploaded.status
            ? fileUploaded.status
            : 'PENDENTE'}
        </Button>
      </td>
      <td style={{ paddingLeft: '1.2rem' }}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Box style={{ paddingTop: 16, width: '100%' }}>
            <MobileDatePicker
              label="Data Emissao"
              inputFormat="DD/MM/YYYY"
              value={dtEmissao}
              maxDate={new Date()}
              onChange={onChangeDtEmissao}
              disabled={loading}
              renderInput={(params) => (
                <TextField
                  error={false}
                  style={{ width: '100%' }}
                  {...params}
                />
              )}
            />
          </Box>
        </LocalizationProvider>
      </td>
      <td style={{ paddingLeft: '1.2rem' }}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Box style={{ paddingTop: 16, width: '100%' }}>
            <MobileDatePicker
              label="Data Validade"
              inputFormat="DD/MM/YYYY"
              minDate={new Date()}
              value={dtValidade}
              onChange={onChangeDtValidate}
              disabled={loading}
              renderInput={(params) => (
                <TextField
                  error={false}
                  style={{ width: '100%' }}
                  {...params}
                />
              )}
            />
          </Box>
        </LocalizationProvider>
      </td>
      <td style={{ paddingLeft: '1.2rem' }}>
        {fileUploaded ? fileUploaded.observacao : ''}
      </td>
      <td style={{ paddingLeft: '1.2rem' }}>
        <div style={{ display: 'flex' }}>
          {loading && <CircularProgress size={20} color="primary" />}
          {!loading && !fileUploaded && (
            <Button variant="contained" component="label">
              <FileUploadIcon size={20} />
              <input
                accept={TIPO_ARQUIVOS_PERMITIDOS.join(',')}
                onChange={onChangeFile}
                type="file"
                hidden
              />
            </Button>
          )}
          {!loading && fileUploaded && (
            <Button
              variant="contained"
              color="error"
              component="label"
              onClick={onClickDelete}
            >
              <DeleteIcon size={20} />
            </Button>
          )}
          {!loading && fileUploaded && (
            <Button
              href={fileUploaded.link}
              target="_blank"
              style={{ marginLeft: 4 }}
              rel="noopener noreferrer"
              variant="contained"
            >
              <OpenInNewIcon size={20} />
            </Button>
          )}
        </div>
      </td>
    </tr>
  );
};
